import type { UntypedFunction } from '@mnd-frontend/ts';
import type React from 'react';
import type { FC } from 'react';
import Screen from '../Screen';

type FaceHugggerProps = {
  show?: boolean;
  background?: string;
  lockedHeight?: boolean;
  onDismiss?: UntypedFunction;
  children?: React.ReactNode;
  lockFocus?: boolean;
};

const Facehugger: FC<FaceHugggerProps> = ({
  children,
  show,
  onDismiss,
  background,
  lockedHeight = false,
  lockFocus,
}) => (
  <Screen
    lockFocus={lockFocus}
    show={show}
    escapeToDismiss
    onDismiss={onDismiss}
    lockedHeight={lockedHeight}
    background={background}
  >
    {children}
  </Screen>
);

export default Facehugger;
